<template>
  <a class="article-item-container" :href="post.link">
    <div>
      <img :src='this.post.thumbnail != "" ? this.post.thumbnail : this.thumbnailPlaceholderUrl' />
      <h3 class="article__text-title" v-html="title"></h3>
    </div>
  </a>
</template>
<script>
export default {
  props: ["post", "index", "thumbnailPlaceholderUrl"],
  data: function() {
    return {};
  },
  computed: {
    title() {
      let title;
      if (this.post.title) {
        title = this.post.title.rendered;
      } else {
        title = "";
      }
      return title;
    },
  },
  methods: {}
};

</script>

<style lang="scss" scoped>
.article-item-container > div img {
  height: 240px;
  width: 100%;
  object-fit: cover;
}
</style>
